import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import AbstractSlideTransform from '@app/transforms/slides/AbstractSlideTransform';
import IPriceItem from '@app/types/data/base/IPriceItem';
import IPriceTableRow from '@app/types/data/base/IPriceTableRow';
import IOfferASlideData from '@app/types/data/slides/IOfferASlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import { Entry } from 'contentful';

/**
 * Transform for 009-OfferASlide
 */
export default class OfferASlideSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'OfferASlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferASlideData> {
		const data: IOfferASlideData = {
			...(await super.transform(slide, presentationSettings)),
			priceList: slide.fields.list.map((item: Entry<any>): IPriceTableRow => {
				const row: IPriceTableRow = {
					label: item.fields.title as IPriceTableRow['label'],
					// eslint-disable-next-line
					image: item.fields.image
						? {
							...this.transformImageAsset((item.fields.image as Entry).fields.asset as any, {
								width: 140,
								height: 140,
								crop: 'fill'
							}),
							aspectRatio: '1x1'
						  }
						: undefined,
					operatingTime: typeof slide.fields.operatingTime === 'object' ? undefined : slide.fields.operatingTime,
					operatingTimes: AbstractSlideTransform.parseObjectWithOperatingTimes(item)
				};

				const individualPrices: IPriceItem = {
					adult: (item.fields.priceAdult as IPriceItem['adult']) || 0,
					child: (item.fields.priceChild as IPriceItem['child']) || 0
				};

				const groupPrices: IPriceItem = {
					adult: (item.fields.priceAdultInGroup as IPriceItem['adult']) || 0,
					child: (item.fields.priceChildInGroup as IPriceItem['child']) || 0
				};

				if (Object.values(individualPrices).some((price) => price > 0)) {
					row.individuals = individualPrices;
				}

				if (Object.values(groupPrices).some((price) => price > 0)) {
					row.groups = groupPrices;
				}

				return row;
			})
		};

		return data;
	}
}
